import React, { useEffect, useState } from 'react';
import { Dashboard as DashboardLayout } from 'layouts';
import { useIntl } from 'react-intl';
import { Box, Breadcrumbs, Grid2, Typography } from '@mui/material';
import theme from 'theme';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Card from 'components/Card';
import { useDispatch, useSelector } from 'react-redux';
import {
  getChargeWithMostConsume,
  getComparativeYearConsume,
  getComparativeYearTariff,
  getDayWithMostConsume,
  getFpAvgPerMonth,
  getFPByMeter,
  getTotalsActualMonth,
} from 'js/actions/meterDashboardActions';
import {
  AttachMoney,
  FlashOn,
  Timeline,
  TrendingUp,
} from '@mui/icons-material';
import BarChart from 'components/BarChart';
import { getMonthWithMostConsume } from 'js/actions/meterDashboardActions';
import { MostConsumeChart } from 'components';
import ComparativeChart, {
  Dashboard,
} from 'components/ComparativeYearConsumeChart';
import DayWithMostConsumeChart from 'components/DayWithMostConsumeChart';
import ChargeWithMostConsumeChart from './ChargeWithMostConsumeChart';
import RateVariation from './RateVariation';
import FPDailyAvrgChart from './FPDailyAvrgChart';
import FPGauge from './FPGauge';
import AmountByGroupChart from './AmountByGroupChart';

export default function MeterDashboard() {
  const intl = useIntl();
  const location = useLocation();
  const dispatch = useDispatch();
  const meter = location.state;
  const [FPid, setFPid] = useState(null);
  const [FPdata, setFPdata] = useState([]);
  const {
    totalsactualmonth,
    comparativeYearConsume,
    monthMostConsume,
    dayMostConsume,
    chargeMostConsume,
    comparativeYearTariff,
  } = useSelector((state) => state.meterDashboard);
  const navigate = useNavigate();
  const contractedDemand = meter?.contracted_demand;
  const year = new Date().getFullYear();
  const currentMonth =
    new Date().getMonth() + 1 <= 9
      ? `0${new Date().getMonth() + 1}`
      : new Date().getMonth() + 1;

  useEffect(() => {
    dispatch(getTotalsActualMonth(meter.id));
  }, [meter]);

  useEffect(() => {
    let corpId = meter?.corporative_id;
    let meterId = meter?.id;
    if (corpId && meterId) {
      dispatch(getMonthWithMostConsume(corpId, meterId, year));
      dispatch(getComparativeYearConsume(corpId, meterId, year));
      dispatch(getDayWithMostConsume(corpId, meterId, year, currentMonth));
      dispatch(getChargeWithMostConsume(corpId, meterId));
      dispatch(getComparativeYearTariff(corpId, meterId, [year, year - 1]));
      dispatch(getFPByMeter(meterId, getData));
    }
  }, [meter]);

  const getData = (data) => {
    if (data[0].id) {
      setFPid(data[0].id);
      dispatch(getFpAvgPerMonth(FPid, `${year}${currentMonth}`, getFPAvg));
    }
  };

  useEffect(() => {
    if (FPid) {
      dispatch(getFpAvgPerMonth(FPid, `${year}${currentMonth}`, getFPAvg));
    }
  }, [FPid]); // Se ejecuta cada vez que FPid cambie

  const getFPAvg = (data) => {
    setFPdata(data);
  };

  return (
    <DashboardLayout>
      <Box p={4}>
        <Typography
          variant="h2"
          sx={{ mb: theme.spacing(2), color: '#A53693' }}
        >
          {intl.formatMessage({ id: 'app.meter.board.title' })}
        </Typography>
        <Breadcrumbs aria-label="breadcrumb" separator=":">
          <Link
            underline="hover"
            style={{ color: '#A53693' }}
            to={`/corporative/${meter.corporative_id}`}
          >
            {intl.formatMessage({ id: 'app.meters.nav.meters' })}
          </Link>
          <Typography variant="h5">{meter.name}</Typography>
        </Breadcrumbs>
        <Grid2 container={true} spacing={2} pt={2}>
          <Grid2
            item={true}
            size={{ lg: contractedDemand ? 2.4 : 3, md: 6, sm: 6, xs: 12 }}
          >
            <Card
              bgColor="#A53693"
              title={intl.formatMessage({
                id: 'app.meter.board.mainHead.consumtion',
              })}
              data={
                totalsactualmonth ? `${totalsactualmonth.total_kwh} kWh` : null
              }
              footer={false}
              icon={
                <TrendingUp
                  sx={{
                    color: '#A53693',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          <Grid2
            item={true}
            size={{ lg: contractedDemand ? 2.4 : 3, md: 6, sm: 6, xs: 12 }}
          >
            <Card
              bgColor="#00AFEF"
              title={intl.formatMessage({
                id: 'app.meter.board.mainHead.maxDemand',
              })}
              data={
                totalsactualmonth ? `${totalsactualmonth.demand_max} kW` : null
              }
              footer={false}
              icon={
                <FlashOn
                  sx={{
                    color: '#00AFEF',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          {contractedDemand && (
            <Grid2 item={true} size={{ lg: 2.4, md: 6, sm: 6, xs: 12 }}>
              <Card
                bgColor="#728BC7"
                title={intl.formatMessage({
                  id: 'app.meter.board.mainHead.contractedDemand',
                })}
                data={totalsactualmonth ? `${contractedDemand} kW` : null}
                footer={false}
                icon={
                  <FlashOn
                    sx={{
                      color: '#728BC7',
                      width: '2rem',
                      height: '2rem',
                      fontSize: '2rem',
                    }}
                  />
                }
              />
            </Grid2>
          )}
          <Grid2
            item={true}
            size={{ lg: contractedDemand ? 2.4 : 3, md: 6, sm: 6, xs: 12 }}
          >
            <Card
              bgColor="#45B880"
              title={intl.formatMessage({
                id: 'app.meter.board.mainHead.estimAmtAsOfToday',
              })}
              data={totalsactualmonth ? `$ ${totalsactualmonth.total}` : null}
              footer={intl.formatMessage({
                id: 'app.meter.board.mainHead.estimAmtAsOfToday.vatNotice',
              })}
              icon={
                <AttachMoney
                  sx={{
                    color: '#45B880',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          <Grid2
            item={true}
            size={{
              lg: contractedDemand ? 2.4 : 3,
              md: contractedDemand ? 12 : 6,
              sm: contractedDemand ? 12 : 6,
              xs: 12,
            }}
          >
            <Card
              clicked={true}
              bgColor="#EAAB36"
              title={intl.formatMessage({
                id: 'app.meter.board.mainHead.groups',
              })}
              data={' '}
              footer={false}
              action={() => navigate(`/meter/${meter?.id}`, { state: meter })}
              icon={
                <Timeline
                  sx={{
                    color: '#EAAB36',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
        </Grid2>
        <Grid2 container={true} spacing={2} pt={2}>
          <Grid2 size={{ lg: 9, md: 9, sm: 12, xs: 12 }}>
            <BarChart
              title={intl.formatMessage({
                id: 'app.meter.board.demandAndConsump.title',
              })}
              custom={0}
              totalConsumeskW={totalsactualmonth[0]}
              totalConsumeskWh={totalsactualmonth[1]}
            />
          </Grid2>
          <Grid2 size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
            <MostConsumeChart
              title={intl.formatMessage({
                id: 'app.meter.board.monthHighestConsum.title',
              })}
              year={year}
              monthMostConsume={monthMostConsume}
            />
          </Grid2>
          <Grid2 size={{ lg: 9, md: 9, sm: 12, xs: 12 }}>
            <ComparativeChart
              title={intl.formatMessage({
                id: 'app.meter.board.consumDiference.title',
              })}
              year={year}
              dashboard={Dashboard.individual}
              comparativeYearConsume={comparativeYearConsume}
            />
          </Grid2>
          <Grid2 size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
            <Grid2 size={12} mb={2}>
              <DayWithMostConsumeChart
                title={intl.formatMessage({
                  id: 'app.meter.board.groupHighestConsumMonth.title',
                })}
                groupName={dayMostConsume.group_name}
                consume={dayMostConsume.consume}
                co2={dayMostConsume.co2}
                day={false}
              />
            </Grid2>
            <Grid2 size={12}>
              <ChargeWithMostConsumeChart
                chargeMostConsume={chargeMostConsume}
              />
            </Grid2>
          </Grid2>
          <Grid2 size={12}>
            <RateVariation
              title={intl.formatMessage({
                id: 'app.meter.board.ratesVariation.title',
              })}
              data={comparativeYearTariff}
              year={year}
              lastYear={year - 1}
            />
          </Grid2>
          <Grid2 size={{ lg: 9, md: 9, sm: 12, xs: 12 }}>
            <FPDailyAvrgChart
              title={intl.formatMessage({
                id: 'app.meter.board.fpVariationInMonth.title',
              })}
              data={FPdata}
            />
          </Grid2>
          <Grid2 size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
            <FPGauge meterId={meter.id} meterFp={FPid} />
          </Grid2>
          <Grid2 size={12}>
            <AmountByGroupChart
              corpId={meter.corporative_id}
              meterId={meter.id}
              titleAmount={intl.formatMessage({
                id: 'app.meter.board.amountByGroup.title',
              })}
              titleConsumption={intl.formatMessage({
                id: 'app.meter.board.consumptionByGroup.title',
              })}
            />
          </Grid2>
        </Grid2>
      </Box>
    </DashboardLayout>
  );
}
